import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.UserActionsToolbar.SyncDropdownContent.DisconnectedCompany', {
    disconnectedFromText: 'Disconnected from {integrationName}',
    reconnectButtonText: 'Reconnect',
});
